import { call, put, takeEvery } from 'redux-saga/effects'

import { ApiError } from '../../api/client'
import { authApi } from '../../api/authApi'
import { AUTH_CHECK } from '../actions/auth'
import { authActions } from '../slices/auth'

function* authCheckSaga() {
    try {
        yield put(authActions.setAuthLoading(true))

        const data = yield call(authApi.me)
        const username = data?.username || data?.id_username || ''

        yield put(authActions.setAuthSuccess({ username }))
    } catch (error) {
        if (error instanceof ApiError && (error.status === 401 || error.status === 403)) {
            window.location.replace('/')
            return
        }

        console.error('AUTH ERROR:', error)
        yield put(authActions.setAuthError(
            error instanceof Error ? error.message : 'Не удалось проверить авторизацию.'
        ))
    } finally {
        yield put(authActions.setAuthLoading(false))
    }
}

function* authCheckWatch() {
    yield takeEvery(AUTH_CHECK, authCheckSaga)
}

export default function* authRootSaga() {
    yield authCheckWatch()
}
